import N8nIcon from './Icon.vue';

export default N8nIcon;
export { type IconName, type NodeIconName, isNodeIcon, updatedIconSet } from './icons';
